<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card>
      <b-row>
        <b-col xl="8" lg="8" md="8" sm="12">
          <span class="f-g">
            <h1 class="m-0 f-g">Interesse</h1>
          </span>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 w100 mr5"
              @click="save"
              >Confirmar</b-button
            >
            <b-button
              variant="primary"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="verificaInteresse"
            >
              Excluir
            </b-button>

            <b-button
              variant="danger"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="goBack"
            >
              <i class="fa fa-arrow-left"></i>
              Voltar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card header="Descrição" class="mt-2">
      <b-row>
        <b-col xl="12" lg="6" md="6" sm="6">
          <b-form-group>
            <b-input-group size="md" prepend="Descritivo">
              <b-form-input
                type="search"
                id="description"
                placeholder="Digite a descrição do interesse"
                v-model="descricao"
                autofocus
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col xl="12" lg="6" md="6" sm="12">
        <b-card header="Imagem" class="mb-0 mt-2">
          <picture-input
            ref="pictureInput"
            margin="1"
            style="width: 20%; heigth: 20%"
            accept="image/*"
            :autoToggleAspectRatio="true"
            :removable="false"
            size="10"
            :zIndex="10"
            button-class="changeBtn"
            removeButtonClass="removeBtn"
            :prefill="url"
            :custom-strings="{
              upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
              drag: 'Arraste uma imagem <br> (ou clique aqui)',
              change: 'Mudar foto',
              remove: 'Remover foto',
            }"
            @change="onChange"
          ></picture-input>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import PictureInput from "vue-picture-input";
import Loading from "vue-loading-overlay";

export default {
  name: "interesse",
  components: { PictureInput, Loading },
  data: () => {
    return {
      currentPageSetor: 1,
      perPageSetor: 5,
      totalRowsSetor: 1,
      isLoading: false,
      url: null,
      totalCustomers: 0,
      saveBtn: false,
      descricao: null,
    };
  },

  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        localStorage.setItem("image", image);
      } else {
        this.saveBtn = false;
      }
    },

    goBack() {
      localStorage.removeItem("desc_interesse");
      localStorage.removeItem("img_interesse");
      localStorage.removeItem("id_interesse");
      localStorage.removeItem("totalCustomers");

      this.isLoading = false;
      this.$router.go(-1);
    },

    async verificaInteresse() {
      if (this.totalCustomers > 0) {
        const res = await this.$swal({
          title: "Interesse",
          text: `Existem ${this.totalCustomers} clientes vinculados ao interesse ${this.descricao}. Deseja realmente exclui-lo?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        });

        if (res.value) {
          await this.deletaInteresse(this.id);
        }
      } else {
        await this.deletaInteresse(this.id);
      }
    },

    async deletaInteresse(interesseId) {
      const url = `${
        config.default.servidor
      }/gerencial/interesse/${interesseId}/empresa/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "delete",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          await this.$alert("Interesse excluído!", "Sucesso", "success");
          this.goBack();
        }
      } catch (error) {
        console.log({ error });
        await this.$alert("Falha ao excluir o interesse!", "Erro", "error");
      }
    },

    async save() {
      if (this.id != null) {
        const url = `${config.default.servidor}/gerencial/vincular-imagem-interesse`;
        try {
          this.isLoading = true;
          const response = await axios({
            url,
            method: "put",
            data: {
              idempresa: localStorage.getItem("enterprise_id").toString(),
              idinteresse: this.id,
              descricao: this.descricao,
              imagem: localStorage.getItem("image"),
            },
            headers: { authorization: `${config.default.authorizationBasic}` },
          });

          if (response.status == 200) {
            this.isLoading = false;
            await this.$alert("Interesse editado!", "Sucesso", "success");
            localStorage.removeItem("image");
          } else {
            await this.$alert("Falha ao editar o interesse!", "Erro", "error");
          }
          this.goBack();
        } catch (error) {
          this.isLoading = false;
          await this.$alert("Falha ao editar o interesse!", "Erro", "error");
        }
      } else {
        if (this.descricao != null) {
          const url = `${config.default.servidor}/gerencial/interesse`;
          try {
            this.isLoading = true;
            const response = await axios({
              url,
              method: "post",
              data: {
                idempresa: localStorage.getItem("enterprise_id").toString(),
                descricao: this.descricao,
                imagem: localStorage.getItem("image"),
              },
              headers: {
                authorization: `${config.default.authorizationBasic}`,
              },
            });

            if (response.status == 200) {
              this.isLoading = false;
              await this.$alert("Interesse inserido!", "Sucesso", "success");
              localStorage.removeItem("image");
            } else {
              this.isLoading = false;
              await this.$alert(
                "Falha ao inserir o interesse!",
                "Erro",
                "error"
              );
            }
            this.goBack();
          } catch (error) {
            this.isLoading = false;
            await this.$alert("Falha ao inserir o interesse!", "Erro", "error");
          }
        } else {
          this.isLoading = false;
          await this.$alert(
            "Preencha todos os campos antes de continuar!",
            "Aviso",
            "warning"
          );
        }
      }
      this.isLoading = false;
    },
  },

  async beforeMount() {
    this.isLoading = true;
    this.id = localStorage.getItem("id_interesse");
    this.descricao = localStorage.getItem("desc_interesse");
    this.url = localStorage.getItem("img_interesse");
    this.totalCustomers = localStorage.getItem("totalCustomers");
    this.isLoading = false;
  },
};
</script>
